import React from "react";
import { DatePicker, Text } from "react_reusable_components";
import { ThreeRow } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";
import { useIntl } from "react-intl";
import "./DatePickerContainer.scss";
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat'; // Import the customParseFormat plugin
import advancedFormat from 'dayjs/plugin/advancedFormat'
import localeData from 'dayjs/plugin/localeData'
import weekday from 'dayjs/plugin/weekday'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekYear from 'dayjs/plugin/weekYear'

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)

export const customInputStyle = {
  style: {
    position: "relative",
    overflow: variables.unset,
  },
  iconStyle: { fontSize: variables.fontSizeXlarge },
  errorStyle: {
    marginTop: variables.marginSmallest,
    lineHeight: variables.lineHeightSmall,
    fontSize: variables.fontSizeSmall,
    position: "absolute",
  },
  labelStyle: {
    color: variables.textDefault,
    marginBottom: variables.marginSmall,
    lineHeight: variables.lineHeightSmall,
    fontSize: variables.fontSizeNormal,
  },
  inputStyle: (size) => ({
    padding:
      size === "small"
        ? `${variables.paddingSmall3} ${variables.paddingSmall}`
        : variables.paddingSmedium,
    fontSize: variables.fontSizeNormal,
    zIndex: 0,
    ...(size === "small" && { height: variables.mediumHeight }),
    width: variables.fullWidth,
  }),
  requiredStyle: {
    color: variables.primaryBg,
  },
  pickerWrapper: { width: variables.fullWidth },
};

export default function DatePickerContainer({
  style,
  value,
  onChange,
  className,
  placeholder,
  label,
  labelProps,
  isPassword,
  required,
  error,
  size,
  disabledDate,
  ...props
}) {
  const intl = useIntl();
  const DATE_FORMAT = intl.formatMessage({ id: "date.format" });

  return (
    <ThreeRow
      style={customInputStyle.style}
      topSection={
        label && (
          <Text style={customInputStyle.labelStyle}>
            {label}
            {required && (
              <Text style={customInputStyle.requiredStyle}>&nbsp;*</Text>
            )}
          </Text>
        )
      }
      middleSection={
        <div
          className="custom-date-picker"
          style={customInputStyle.pickerWrapper}
        >
          <DatePicker
            style={{ ...customInputStyle.inputStyle(size), ...style }}
            onChange={(_, str) => {
              onChange(str);
            }}
            placeholder={placeholder}
            className={className}
            format={DATE_FORMAT}
            disabledDate={disabledDate}
            value={value ? dayjs(value, DATE_FORMAT) : null}
            {...props}
          />
        </div>
      }
      bottomSection={
        !!error && (
          <Text style={customInputStyle.errorStyle} type="danger">
            {error}
          </Text>
        )
      }
    />
  );
}
